/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

interface ScannerIconProps extends SVGProps<SVGSVGElement> {
  fill?: string;
  height?: number;
  width?: number;
}

const ScannerIcon = ({ fill, height, width, ...restProps }: ScannerIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 21 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
    data-palette="ScannerIcon">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.236 3.5A2.75 2.75 0 0 1 4.986.75h3.56v1.5h-3.56c-.69 0-1.25.56-1.25 1.25v3.56h-1.5V3.5Zm16.592 0a2.75 2.75 0 0 0-2.75-2.75h-3.56v1.5h3.56c.69 0 1.25.56 1.25 1.25v3.56h1.5V3.5ZM4.986 18.25a2.75 2.75 0 0 1-2.75-2.75v-3.56h1.5v3.56c0 .69.56 1.25 1.25 1.25h3.56v1.5h-3.56Zm13.842-2.75a2.75 2.75 0 0 1-2.75 2.75h-3.56v-1.5h3.56c.69 0 1.25-.56 1.25-1.25v-3.56h1.5v3.56ZM.625 8.5a.625.625 0 1 0 0 1.25h19.75a.625.625 0 1 0 0-1.25H.625Z"
      fill={fill}
    />
  </svg>
);

ScannerIcon.defaultProps = {
  fill: 'currentColor',
  width: 21,
  height: 19,
};

export default ScannerIcon;
